document.addEventListener('DOMContentLoaded', function () {
  const banner = document.querySelector('.scrolling-text');
  banner.style.animation = 'none'; // Remove animation for fallback
  
  let speed = 2; // Scrolling speed (higher is faster)
  let direction = 1; // 1 for left-to-right, -1 for right-to-left
  
  function scrollBanner() {
    const currentX = banner.getBoundingClientRect().left;
    const endX = -banner.offsetWidth;

    if (currentX <= endX) {
      banner.style.transform = `translateX(${window.innerWidth}px)`;
    } else {
      banner.style.transform = `translateX(${currentX - speed * direction}px)`;
    }
    requestAnimationFrame(scrollBanner);
  }
  scrollBanner();
});
